module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.openDialog()
      }
    }
  }, [_vm._v("添加页面")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-select', {
    attrs: {
      "size": "mini",
      "placeholder": "状态"
    },
    model: {
      value: (_vm.params.is_open),
      callback: function($$v) {
        _vm.$set(_vm.params, "is_open", $$v)
      },
      expression: "params.is_open"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "页面ID",
      "size": "mini"
    },
    model: {
      value: (_vm.params.id),
      callback: function($$v) {
        _vm.$set(_vm.params, "id", $$v)
      },
      expression: "params.id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题",
      "size": "mini"
    },
    model: {
      value: (_vm.params.page_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "page_name", $$v)
      },
      expression: "params.page_name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 140
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "页面id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "page_name",
      "label": "页面名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "page_description",
      "label": "页面描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否启用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_open == '0') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("禁用")]) : _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("启用")])]
      }
    }], null, false, 2172410007)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.delPage(scope.row.id)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "round": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.temDialog(scope.row.id)
            }
          }
        }, [_vm._v("页面装修")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "round": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.removeCache(scope.row.id)
            }
          }
        }, [_vm._v("清除缓存")])]
      }
    }], null, false, 3084677082)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.page_dialog,
      "close-on-click-modal": false,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.page_dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "200px"
    },
    model: {
      value: (_vm.pageForm),
      callback: function($$v) {
        _vm.pageForm = $$v
      },
      expression: "pageForm"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "页面名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "页面名称"
    },
    model: {
      value: (_vm.pageForm.page_name),
      callback: function($$v) {
        _vm.$set(_vm.pageForm, "page_name", $$v)
      },
      expression: "pageForm.page_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "页面描述"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "页面描述"
    },
    model: {
      value: (_vm.pageForm.page_description),
      callback: function($$v) {
        _vm.$set(_vm.pageForm, "page_description", $$v)
      },
      expression: "pageForm.page_description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景色"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "格式#ffffff"
    },
    model: {
      value: (_vm.pageForm.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.pageForm, "bg_color", $$v)
      },
      expression: "pageForm.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.pageForm.is_open),
      callback: function($$v) {
        _vm.$set(_vm.pageForm, "is_open", $$v)
      },
      expression: "pageForm.is_open"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.savePage
    }
  }, [_vm._v("确认保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.template_dialog,
      "width": "80%",
      "title": "编辑页面",
      "fullscreen": "",
      "lock-scroll": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.template_dialog = $event
      }
    }
  }, [_c('shopDecoration', {
    attrs: {
      "id": _vm.pageForm.id,
      "usage": "page",
      "template_name": _vm.template_name
    },
    on: {
      "saved": _vm.closeDialog
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c71382fc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c71382fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/custompage.vue
// module id = 2929
// module chunks = 0